import React from 'react';
import PowertrainConditionMonitoringComponent from './PowertrainConditionMonitoringComponent';

const PowertrainConditionMonitoringContainer = (props) => {
    return <PowertrainConditionMonitoringComponent {...props} />;
};


export default PowertrainConditionMonitoringContainer;
